import React, { useState, useEffect } from "react";

import Input from "@mui/material/Input";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import EmailIcon from "@mui/icons-material/Email";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export default function FirstStep({ dispatchChangeStep }) {
  const [email, setEmail] = useState(Window.signInForm_1_email || "");
  const [password, setPassword] = useState(Window.signInForm_1_password || "");
  const [passwordConfirm, setPasswordConfirm] = useState(
    Window.signInForm_1_passwordConfirm || ""
  );
  const [formRequirements, setFormRequirements] = useState(
    Window.signInForm_1_formRequirements || {
      emailValid: isEmailValid(window.signInForm_1_email),
      charactersNumber: false,
      atLeastACapitalLetter: false,
      lettersAndNumbers: false,
      confirmPassword: false,
    }
  );

  const [passwordVisible, setPasswordVisible] = useState(false);

  useEffect(handleEmailValidation, [email]);
  useEffect(handlePasswordValidation, [password]);
  useEffect(handleConfirmPasswordValidation, [passwordConfirm]);

  useEffect(() => {
    setTimeout(() => {
      handlePasswordValidation();
      handleConfirmPasswordValidation();
      handleEmailValidation();
    }, 1000);
  }, []);

  function handleEmailValidation(bypassUpdate = false) {
    const newFormRequirements = { ...formRequirements };
    newFormRequirements.emailValid = isEmailValid(email);
    Window.signInForm_1_formRequirements = newFormRequirements;
    console.log("Email", email, newFormRequirements);

    if (bypassUpdate) return newFormRequirements.emailValid;
    setFormRequirements({ ...newFormRequirements });
  }
  function isEmailValid(value) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
  }
  function handlePasswordValidation() {
    const newFormRequirements = { ...formRequirements };
    newFormRequirements.charactersNumber =
      password.replaceAll(" ", "").length >= 8;
    newFormRequirements.atLeastACapitalLetter = /[a-z]/.test(password);
    newFormRequirements.lettersAndNumbers =
      /^(?=.*[0-9])(?=.*[a-zA-Z])(?=\S+$)/.test(password) &&
      password.replaceAll(" ", "").length >= 2;
    newFormRequirements.confirmPassword =
      passwordConfirm === password && !!password;

    Window.signInForm_1_formRequirements = newFormRequirements;
    setFormRequirements({ ...newFormRequirements });
  }
  function handleConfirmPasswordValidation() {
    const newFormRequirements = { ...formRequirements };
    newFormRequirements.confirmPassword =
      passwordConfirm === password && !!password;

    Window.signInForm_1_formRequirements = newFormRequirements;
    setFormRequirements({ ...newFormRequirements });
  }

  function handleNextStep(e) {
    e?.preventDefault();
    dispatchChangeStep({ current: 1, goTo: 2 });
  }
  function isFormValid() {
    console.log(
      "Valid",
      formRequirements,
      formRequirements.emailValid &&
        formRequirements.charactersNumber &&
        formRequirements.atLeastACapitalLetter &&
        formRequirements.lettersAndNumbers &&
        formRequirements.confirmPassword
    );
    return (
      formRequirements.emailValid &&
      formRequirements.charactersNumber &&
      formRequirements.atLeastACapitalLetter &&
      formRequirements.lettersAndNumbers &&
      formRequirements.confirmPassword
    );
  }
  function handleInputFocus(e) {
    document.getElementById(e.target.id).scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  }

  const TogglePasswordVisibilityIcon = ({ isVisible }) => {
    const Icon = isVisible ? RemoveRedEyeIcon : VisibilityOffIcon;
    return (
      <Icon
        style={{ cursor: "pointer" }}
        onClick={() => setPasswordVisible(!passwordVisible)}
      />
    );
  };

  return (
    <form onSubmit={handleNextStep} className="signin-form mt-2">
      <Field
        onFocus={handleInputFocus}
        label="Seu email"
        placeholder="seu@email.com"
        endAdornment={<EmailIcon />}
        onInput={(v) => {
          Window.signInForm_1_email = v.target.value;
          setEmail(v.target.value);
        }}
        value={email}
      />

      <Field
        onFocus={handleInputFocus}
        label="Senha"
        placeholder="*********"
        endAdornment={<TogglePasswordVisibilityIcon />}
        onInput={(v) => {
          Window.signInForm_1_password = v.target.value;
          setPassword(v.target.value);
        }}
        value={password}
        type={passwordVisible ? "text" : "password"}
      />

      <Field
        onFocus={handleInputFocus}
        label="Confirmar senha"
        placeholder="*********"
        endAdornment={<TogglePasswordVisibilityIcon />}
        onInput={(v) => {
          Window.signInForm_1_passwordConfirm = v.target.value;
          setPasswordConfirm(v.target.value);
        }}
        value={passwordConfirm}
        type={passwordVisible ? "text" : "password"}
      />

      <PasswordIndicators states={formRequirements} key={Math.random()} />

      <Button
        variant="contained"
        disabled={!isFormValid()}
        color="primary"
        className="signin-btn py-2 mt-3"
        startIcon={<ArrowForwardIosIcon />}
        onClick={handleNextStep}
        type="submit"
        key={Math.random()}
      >
        Próxima etapa: Informações de contato
      </Button>
      <Button
        variant="outlined"
        onClick={() => window.navigate("/")}
        color="primary"
        className="signin-btn py-2"
        type="button"
      >
        Voltar
      </Button>
    </form>
  );
}

const Field = ({
  onFocus,
  label,
  placeholder,
  endAdornment,
  onInput,
  value,
  type = "text",
}) => {
  return (
    <TextField
      onFocus={onFocus}
      label={label}
      placeholder={placeholder}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">{endAdornment}</InputAdornment>
        ),
      }}
      onInput={onInput}
      variant="outlined"
      color="primary"
      value={value}
      type={type}
      className="slide-right-fade mt-1 mb-2"
      style={{ animationDelay: "0.1s" }}
    />
  );
};

const PasswordIndicators = ({ states }) => {
  const requirements = {
    charactersNumber: "No mínimo 8 caracteres",
    atLeastACapitalLetter: "Pelo menos uma letra minúscula",
    lettersAndNumbers: "Letras e números",
    confirmPassword: "As duas senhas inseridas devem ser iguais",
  };

  return (
    <div
      className="confirm-password-indicators"
      style={{ animationDelay: "0.2s" }}
    >
      {Object.keys(requirements).map((requirement, i) => (
        <Typography variant="h5" component="h5">
          <span
            className="indicator-circle"
            style={{
              backgroundColor:
                !!states && !!states[requirement] ? "green" : "#c4c4c4",
            }}
          />
          {requirements[requirement]}
        </Typography>
      ))}
    </div>
  );
};
